import dayjs from 'dayjs'
import { ViewModel } from './_vm'
import RoomChangeTemplate from './_roomChangeTemplate'
import ConfigForm from './service/_config'
import FormStore from './store/_form-store'
import { dateFormat, objectToGet } from '../functions/index'
import closingDay from '../const/_closing-day'
import UiStore from '../store/_ui-store'

/**
 * TopRoomsInfo // datePicker描写のjs
 *
 * @returns {undefined}
 */
export class TopRoomsInfo extends ViewModel {
  constructor($element, controller) {
    super(TopRoomsInfo.name(), $element, controller)

    // 年と月の初期化
    this.$text = this.$element

    // イベントの登録
    this.on(`TopRoomsInfo:render`, () => this.render())

    this.render()
  }

  static name() {
    return 'TopRoomsInfo'
  }

  static className() {
    return '.js-tour-detail-rooms-info'
  }

  render() {
    let peopleNumRoomNum = ''
    const roomList = UiStore.getData('lockRooms.roomList', [[20, 20]])
    console.log('roomList', roomList)
    const peopleNum = roomList.join().split(',').length
    const roomNum = roomList.length

    const totalAdult = UiStore.getData(`totalAdult`, 2)
    const totalChild = UiStore.getData(`totalChild`, 0)
    const totalInf = UiStore.getData(`totalInf`, 0)

    peopleNumRoomNum =
      roomNum +
      '部屋／大人' +
      totalAdult +
      '名　子供' +
      totalChild +
      '名　幼児' +
      totalInf +
      '名　(合計' +
      (totalAdult + totalChild + totalInf) +
      '名)'
    this.$text.empty()
    this.$text.append(peopleNumRoomNum)
  }
}
